export type DeviceInfo = {
  isMobileOrTablet: boolean;
  isChromeOnAppleDevice: boolean;
  isFirefoxOnAppleDevice: boolean;
  isOperaTouchOnAppleDevice: boolean;
  isIos: boolean;
  isAndroid: boolean;
  isSafari: boolean;
  isFirefox: boolean;
  isChrome: boolean;
};

export const useDeviceInfo = (): DeviceInfo => {
  const {
    isMobileOrTablet,
    userAgent,
    isSafari,
    isFirefox,
    isChrome,
    isIos,
    isAndroid,
  } = useDevice();

  const isChromeOnAppleDevice = !!userAgent.match(/CriOS/);
  const isFirefoxOnAppleDevice = !!userAgent.match(/FxiOS/);
  const isOperaTouchOnAppleDevice = !!userAgent.match(/OPT/);

  return {
    isMobileOrTablet,
    isChromeOnAppleDevice,
    isFirefoxOnAppleDevice,
    isOperaTouchOnAppleDevice,
    isIos,
    isAndroid,
    isSafari,
    isFirefox,
    isChrome,
  };
};
